import ol = require("ol");
import Utils = require("../utils");
import Portal = require("portal-gis");
import Mediator = require("../mediator");
import MapView = require("../views/MapView");
import Base = require("./base-command");
import Converter = require("../utils/ol3/converter");

class Command extends Base<any> {

    static about = `
Requests all features from all layers to be unselected.
`;

    static output = {
        "selected": {
            "about": "always empty",
        },
        "unselected": {
            "about": "list of features that were previously selected",
        },
    }
    
    execute(args = this.args) {

        this.mediator.mapViewMap(map => {

            let converter = new Converter(map.getView().getProjection().getCode());

            let layers = map.getLayers().getArray()
                .filter(l => l instanceof ol.layer.Vector)
                .map(l => <ol.layer.Vector>l);

            let unselected = [];

            layers.forEach(l => {
                l.getSource().getFeatures().forEach(f => {
                    if (Utils.extend(f).selected) {
                        Utils.extend(f).selected = false;
                        unselected.push(f);
                    }
                });
            });

            this.trigger({
                selected: [],
                unselected: converter.fromNativeFeatures(unselected).features
            });
        });

    }

}

export = Command; 